import React, { useState, useEffect,useRef } from "react";
import ReactPaginate from "react-paginate";
import axios from 'axios';
import { getUserId } from '../utils/common';
import Modal from './Modal';
import ModalSale from './ModalSale';
import AddSale from './AddSaleM';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {aPIURL,auTHURL} from '../utils/common';
import { useReactToPrint } from 'react-to-print';
import { useDownloadExcel } from "react-export-table-to-excel";


const SubscriptionRenewal = () => {

   const [chkflag ,setChkflag] = useState(false);
   const [subscriptionFor ,setSubscriptionFor] = useState(1);
   const tableRef = useRef(null);
   const API_URL=aPIURL();
   const [post, setPost] = useState([]);
   const [order, setOrder] = useState("ASC");
   const [number, setNumber] = useState(1); 
   const [postPerPage] = useState(10);
   const [showAddSaleDevice, setShowAddSaleDevice]= useState(false);
   const [showDetails, setShowDetails]= useState(false);
   const [inputs, setInputs] = useState({});
   const [customerData, setCustomerData]= useState([]);
   const [subscriptionDurationData, setSubscriptionDurationData]= useState([]);
   const [custID, setCustID]=useState(0);
  
   const [subscriptionData,setSubscriptionData]= useState([]);
   const [saleSubscriptionTypeID, setSaleSubscriptionTypeID]=useState(0);
   const [dModel, setDModel]=useState("GPS-V5");
   const [devicestock, setDevicestock]=useState(0);
   const [filteredSaleDeviceDetails,setFilteredSaleDeviceDetails]= useState([]);
   const [saleDeviceData,setSaleDeviceData]= useState([]);
   const [deviceCost,setdeviceCost]=useState(0);
   const [currencyType,setCurrencyType]=useState("INR");
   const [termType,setTermType]=useState(0);
   let newduedate="";
   const d = new Date();
   let [due_Date,setDue_Date]= useState("");
   const [renewalDeviceData, setRenewalDeviceData] = useState([]);
   const [cDisplay, setCDisplay]= useState('none');
   let DeviceIEMI_Number=0;
   let DeviceSIM_Number=0;
   let DeviceExpirationDate="";
   let devID=0;
   let chkID=0;
   let checkStatus=false;
   const [cGstPer, setCGstPer]=useState(0);
   const [sGstPer, setSGstPer]=useState(0);
   const [iGstPer, setIGstPer]=useState(0);
   const [cGstVal, setCGstVal]=useState(0.00);
   const [sGstVal, setSGstVal]=useState(0.00);
   const [iGstVal, setIGstVal]=useState(0.00);
   let [discountVal, setDiscountVal]=useState(0.00);
   let [insChargeVal, setInsChargeVal]=useState(0.00);
   let [gTotalVal, setGTotalVal]=useState(0.00);
   let [totAmount,setTotAmount]=useState(0.00);
   let [payableAmount,setPayableAmount]=useState(0.00);
   let [quantity, setQuantity]=useState(0);
   let [invoiceType,setInvoiceType]=useState("Device Renewal");
   const [btnDisplay, setBtnDisplay]= useState('none');

useEffect(() => {
      
         
         FillGrid(0);   
         
    }, []);
  
  const lastPost = number * postPerPage;
  const firstPost = lastPost - postPerPage;
  const currentPost = post.slice(firstPost, lastPost);
  const PageCount = Math.ceil(post.length / postPerPage);
  let rc=1;

const ChangePage = ({ selected }) => {
        
        setNumber(selected+1);
  };



const showDetailsModal = (index) => {  

    const invoice_ID = index;   
    setShowDetails(true);
           
    const updatedDeviceList = post.filter((custElem) => {          
    
    return custElem.invoiceID === invoice_ID;

  });
   
  setFilteredSaleDeviceDetails(updatedDeviceList);   

   
   const dcurls=API_URL+`GpsSoldDevicebyId/${invoice_ID}/`;  
   alert(dcurls)
   axios.get(dcurls).then(response => 
    {                            
      setSaleDeviceData(response.data.data);        
    }
  ).catch(function(error) 
  { 
    console.log(error.message); 
  });  
}
const sorting=(col)=>
{

  try
  {
    if(order==="ASC")
    {
            const sorted=[...post].sort((a,b)=>
            a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1
            );
            setPost(sorted);
            setOrder("DSC");
    }
    if(order==="DSC")
    {
            const sorted=[...post].sort((a,b)=>
            a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1
            );
            setPost(sorted);
            setOrder("ASC");
    }
  }
  catch(error) 
  {
    console.log(error.message);
  }            
}

const ChangeCurrency=(e)=>
{
    setCurrencyType(e.target.value);    
}

const ChangeTerms=(e)=>
{
     let dterms=0;
     dterms=e.target.value;
     setTermType(dterms);
     
    
    if(e.target.value==7)
    {
        d.setDate(d.getDate() + 7);
    }
   else if(e.target.value==15)
    {
        d.setDate(d.getDate() + 15);
    }
   else if(e.target.value==30)
    {
        d.setDate(d.getDate() + 30);
    }
    else if(e.target.value==60)
    {
        d.setDate(d.getDate() + 60);
    }
    else
    {
        d.setDate(d.getDate());
    }
    let ddate=d.getDate()
    let dmonth=d.getMonth()+ 1;
    let dyear=d.getFullYear();
    if(dmonth<10)
    {
      dmonth='0'+dmonth;
    }
    newduedate=  ddate + "-" + dmonth + "-" + dyear;
    setDue_Date(newduedate);    
}
const FillGrid=(Type_ID)=>
{
       
        const custurls=API_URL + 'GpsCustomerAllList/?TypeID=0'; 
         axios.post(custurls).then(response => 
          {      
              const updatedCustomerList = response.data.data.filter((curElem) => {
                   return curElem.status === "Active";
          });
         setCustomerData(updatedCustomerList); 
         }).catch(function(error) 
         { 
              console.log(error.message);
         }); 

        
         setSubscriptionFor(1);
         setInvoiceType("Device Renewal");  
         FillSubscriptionDuration(1);
}  




const ChangeCustomerID = (e) => {

  //alert(e.target.value);
  setCustID(e.target.value);

}

const ChangeDMode=(e)=>
{
         setDModel(e.target.value);   
}
const changeVHandler = (event) => {
 
  if(event.target.name==='ddiscount')
  {
      
      setCGstPer(0);
      setSGstPer(0);
      setIGstPer(0);
      setCGstVal(0.00);
      setSGstVal(0.00);
      setIGstVal(0.00);

      setDiscountVal(event.target.value);
      setGTotalVal((parseFloat(totAmount,2)  - event.target.value) + parseFloat(insChargeVal,2) + parseFloat(cGstVal,2)+ parseFloat(sGstVal,2)+ parseFloat(iGstVal,2)); 
      setPayableAmount((parseFloat(totAmount,2)  - event.target.value) + parseFloat(insChargeVal,2));   

  }
  else if(event.target.name==='installationcharge')
  {
      setSGstPer(0);
      setCGstPer(0);
      setIGstPer(0);
      setCGstVal(0.00);
      setSGstVal(0.00);
      setIGstVal(0.00);

      setInsChargeVal(event.target.value);
      setGTotalVal((parseFloat(totAmount,2) - parseFloat(discountVal,2)) + parseFloat(event.target.value)+ parseFloat(cGstVal,2)+ parseFloat(sGstVal,2)+ parseFloat(iGstVal,2));
      setPayableAmount((parseFloat(totAmount,2)  - parseFloat(discountVal,2)) + parseFloat(event.target.value,2));
      //alert(discountVal);
  }
 
  else
  {
      const name = event.target.name;
      const value = event.target.value;
      setInputs(values => ({...values, [name]: value}))
  }
}

const exportStatus = e => {
 
  const value = e.target.value;
  FillGrid(value);
}
const exportDownload = e => 
{  
    const value = e.target.value; 

if(value=="Excel")
{
     onDownload();
}
if(value=="PDF")
{
      handlePrint(null, () => tableRef.current);
}
}
const { onDownload } = useDownloadExcel({
currentTableRef: tableRef.current,
filename: "Device Details",
sheet: "Devices"
});

const handlePrint = useReactToPrint({
documentTitle: "Device Details",
onBeforePrint: () => console.log("before printing..."),
onAfterPrint: () => console.log("after printing..."),
removeAfterPrint: true,
});

const ChangeDModel=(e)=>
  {
         setDModel(e.target.value);   
  }
const FillSubscriptionDuration=(typeId)=>
  {
    
    setSubscriptionData([]);
    axios.get(API_URL+`Subscribe/${typeId}`).then(response => 
    {
          setSubscriptionData(response.data.data); 

    }).catch(function(error) 
    {
          console.log(error.message); 
    }); 
 

  }
const setSubscription_Type =(event) =>
  {
      //alert(event.target.value);
       if(event.target.value==1)
       {    
              setSubscriptionFor(1); 
              FillSubscriptionDuration(1);          
              setInvoiceType("Device Renewal");  
       }
       else
       {
              setSubscriptionFor(2);
              FillSubscriptionDuration(2);    
              setInvoiceType("Sim Renewal");       
       }       
  }
const ChangeSubscriptionType=(e)=>
    {
          let durationID= 0;
          durationID=e.target.value;
          setSaleSubscriptionTypeID(durationID);  
          //inputs.deviceCost=perdevCost*durationID;
          
    }
const SubmitClick=()=>
    {
      if (custID == 0) 
        {
              toast.error('Please Select Customer.')
              return
        }
        else if(saleSubscriptionTypeID== 0)
        {
              toast.error('Please Select Subscription Duration.')
              return
        }
        else if(inputs.invoicedate==='' || (!inputs.invoicedate))
          {
            toast.error('Please Select Invoice Date.')
            return
          }
        else if(inputs.SaleBy==='' || (!inputs.SaleBy))
        {
          toast.error('Sales Person is required.')
          return
        }
        else if(currencyType== "0")
        {
              toast.error('Currency is required.')
              return
        }
        else if(termType== "0")
        {
              toast.error('Payment Terms is required.')
              return
        }
        else if(inputs.deviceCost==='' || inputs.deviceCost==='0' || (!inputs.deviceCost))
        {
              toast.error('Price is required.')
              return
  
        }         
        
        else
        {
          //GpsRenewalDeviceAllList/?AccountID=6
          const curls=API_URL+`GpsRenewalDeviceAllList/?AccountID=${custID}`;     
          //alert(curls);
           axios.get(curls).then(response => 
            {        
                   // alert("hi");   
                    //console.log("----------------------------renewal data--------------------------------------");
                     //console.log(response.data);
                                             
                     setRenewalDeviceData(response.data.data);
                     console.log(renewalDeviceData);
                     setCDisplay('block');
                     setBtnDisplay('block');      
         
            }).catch(function(error) { 
              toast.error("No device available for renewal."); 
              console.log(error.message); 
              setCDisplay('none');

            });   
          }        

    }
const SaveData=()=>
      {

        if (custID == 0) 
          {
                toast.error('Please Select Customer.')
                return
          }
         
          else if(saleSubscriptionTypeID== 0)
          {
                toast.error('Please Select Subscription Duration.')
                return
          }
          else if(inputs.invoicedate==='' || (!inputs.invoicedate))
            {
              toast.error('Please Select Invoice Date.')
              return
            }
          else if(inputs.SaleBy==='' || (!inputs.SaleBy))
          {
            toast.error('Sales Person is required.')
            return
          }
          else if(currencyType== "0")
          {
                toast.error('Currency is required.')
                return
          }
          else if(termType== "0")
          {
                toast.error('Payment Terms is required.')
                return
          }
          else if(inputs.deviceCost==='' || inputs.deviceCost==='0' || (!inputs.deviceCost))
          {
                toast.error('Price is required.')
                return
    
          }      
          else if(gTotalVal == 0.00)   
            {
              toast.error('Please select device from list.')
              return
  
        }  
          else
          {
                    RenewalInsert();   
                       

          }
             

      }
 const RenewalInsert=()=>
        {
               //alert("---------sale insert------------");
                  
             

               const params = JSON.stringify({
                   
                    "customerID": parseInt(custID),
                    "invoiceDate": inputs.invoicedate,
                    "model": dModel,
                    "subscriptionDuration": parseInt(saleSubscriptionTypeID),
                    "currency": currencyType,
                    "terms": parseInt(termType),
                    "dueDate": due_Date,
                    "price": parseInt(inputs.deviceCost),
                    "stock": devicestock,
                    "quantity": parseInt(quantity),
                    "totalAmount": totAmount.toString() ,
                    "discount": discountVal.toString(),
                    "installationCharge": insChargeVal.toString(),
                    "cgstPer": parseInt(cGstPer),
                    "cgstVal": cGstVal.toFixed(2),
                    "sgstPer": parseInt(sGstPer),
                    "sgstVal": sGstVal.toFixed(2),
                    "igstPer": parseInt(iGstPer),
                    "igstVal": iGstVal.toFixed(2),
                    "grandTotal": gTotalVal.toFixed(2),
                    "invoiceType": invoiceType                
                  
                });
                  //alert(params);
                
                 //GPSDevice Sale Insert start
                 
                 axios.post(API_URL+'GPSDeviceSaleInsert', params, {
                   
                    "headers": 
                     {
                         "content-type": "application/json",    
                     },
                     })
                     .then(function (response) 
                     {
                             if(!response.data.validStatus)
                             {
                                        //alert("1");
                                        toast.error(response.data.message);                                                                 
                             }
                             else
                             {
                                    //alert("2");
                                   ReadValue(response.data.id);
                                   setBtnDisplay('none');  
                                   toast.success(response.data.message); 
                                                                  
                           }      
                     })
                     .catch(function (error) 
                     {
                           toast.error("Some Error occured while saving sale device record,Please Provide Valid Inputs.");                  
                           console.log(error.message);    
                     });
                     
                     //GPSDevice Sale Insert ends   
                    
        }
        
      
const ReadValue=(ResID)=>
      {
          //alert("read value");
          var table = document.getElementById("example"),rIndex,cIndex;
              
          var i = 0;var col=0;
      
             for(var j=1;j<table.rows.length;j++)
              {
                  
                  for(var col=0;col<table.rows[0].cells.length;col++)
                  { 
      
                         if(table.rows[0].cells[col].innerHTML==="Select")
                         {

                              DeviceIEMI_Number = document.getElementById("checkbox"+j).value;
                              checkStatus =  document.getElementById("checkbox"+j).checked
                              chkID=table.rows[j].cells[col].innerHTML;
                              //alert("Inside SNO");
                              //alert(DeviceIEMI_Number);
                              //alert(checkStatus);
                              //alert(chkID);                                                             
                         } 
                         else if(table.rows[0].cells[col].innerHTML==="Device ID")
                         {
                              //alert("Inside Device ID");
                              devID=table.rows[j].cells[col].innerHTML;
                              //alert(devID);            
                                                                        
                         } 
                         else if(table.rows[0].cells[col].innerHTML==="IMEI#")
                          {
                               //alert("Inside IMEI");
                                DeviceIEMI_Number=table.rows[j].cells[col].innerHTML;
                                //alert(DeviceIEMI_Number);
                                                                    
                          }
                          else if(table.rows[0].cells[col].innerHTML==="SIM#")
                           {
                                // alert("Inside SIM");
                                 DeviceSIM_Number=table.rows[j].cells[col].innerHTML;
                                 //alert(DeviceSIM_Number);
                                                                     
                           }   
                           else if(table.rows[0].cells[col].innerHTML==="Expired Device")
                            {
                                 alert(table.rows[0].cells[col].innerHTML);
                                  DeviceExpirationDate=table.rows[j].cells[col].innerHTML;
                                  //alert(DeviceSIM_Number);
                                                                      
                            }                        
                         else
                         {
      
                         }       
                  }

                  if(checkStatus)
                    {
                      
                      const allotmentparams = JSON.stringify({
                        "accountID": parseInt(custID),
                        "allotmentID": 0,
                        "imeiNumber": DeviceIEMI_Number,
                        "allotmentBy": inputs.SaleBy,
                        "allotyName": "",
                        "deviceID": devID,
                        "subscribeID": parseInt(saleSubscriptionTypeID),
                        "invoiceID": ResID,
                        "rechargeType": invoiceType,
                        "simNumber": DeviceSIM_Number,
                        "price": inputs.deviceCost,
                        "ExpirationDate": DeviceExpirationDate, 
                     
                     });
                    //alert(allotmentparams);
                   
                 

                      axios.post(API_URL+'Device_Renewal/', allotmentparams, {
          
                            "headers": 
                            {
                                  "content-type": "application/json",    
                            },       
                          })
                        .then(function (response) 
                        {
                                //toast.success(response.data.message);              
                        })
                        .catch(function (error) 
                         {
                              //toast.error("Some Error occured while saving record.");
                              //toast.error(error);
                              console.log(error.message);    
                          });
                  }
              }
                
             
      }
               
const ChangeCGST=(e)=>
{
    setCGstPer(e.target.value);     
    setCGstVal(parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00));
    setGTotalVal(parseFloat(payableAmount,2) + (parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00)) +  parseFloat(sGstVal,2) + parseFloat(iGstVal,2));
    
}
const ChangeSGST=(e)=>
{
    
    setSGstPer(e.target.value);     
    setSGstVal(parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00));
    setGTotalVal(parseFloat(payableAmount,2) + (parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00)) + parseFloat(cGstVal,2) +  parseFloat(iGstVal,2));
}
const ChangeIGST=(e)=>
{
    setIGstPer(e.target.value);     
    setIGstVal(parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00));
    setGTotalVal(parseFloat(payableAmount,2) + (parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00)) + parseFloat(cGstVal,2)+ parseFloat(sGstVal,2));
}

const handleChange = (e) => {

       if(e.target.checked)
        {
            setCGstPer(0);
            setSGstPer(0);
            setIGstPer(0);
            setCGstVal(0.00);
            setSGstVal(0.00);
            setIGstVal(0.00);
            setDiscountVal(0);
            setInsChargeVal(0);
            setQuantity(quantity+1);
            setTotAmount((quantity+1)*inputs.deviceCost);
            setGTotalVal((quantity+1)*inputs.deviceCost);
            setPayableAmount((quantity+1)*inputs.deviceCost);
        }
        else
        {
             setCGstPer(0);
             setSGstPer(0);
             setIGstPer(0);
             setCGstVal(0.00);
             setSGstVal(0.00);
             setIGstVal(0.00);
             setDiscountVal(0);
             setInsChargeVal(0);
             setQuantity(quantity-1);
             setTotAmount((quantity-1)*inputs.deviceCost);
             setGTotalVal((quantity-1)*inputs.deviceCost);
             setPayableAmount((quantity-1)*inputs.deviceCost);
        }
}

  return (
       
      <>
    
    
      <div className="container-fluid p-3">
      
        
        <div class="row">
              <div className='col-md-4 col-lg-4 form-group'>
              Customer <span style={{color:"red"}}>&nbsp;*</span><br/>
              <select className="form-control"  name="DCustomerID" value={custID} onChange={ChangeCustomerID} >
              <option value="0">Select Customer</option>
              {customerData.map((e, key) => {
              return <option key={key} value={e.accountID}>{e.customerName}({e.companyName})</option>;
              })}
              </select>
              </div>
              <div className='col-md-2 col-lg-2  form-group' onChange={setSubscription_Type.bind(subscriptionFor)} >
              Renewal For 
              <span style={{color:"red"}}>&nbsp;*</span><br/>
              <input type="radio"  value="1" name="ignitionAlert" checked={subscriptionFor === 1?true:false}/> Device 
             {/* &nbsp;&nbsp;<input type="radio" value="2" name="ignitionAlert" checked={subscriptionFor === 2?true:false}/> Sim*/}
              </div>
              <div className='col-md-2 col-lg-2 form-group'>
              Duration <span style={{color:"red"}}>&nbsp;*</span><br/>               
              <select className="form-control"  name="DSubscriptionType" value={saleSubscriptionTypeID} onChange={ChangeSubscriptionType} >
              <option value={0}>Select Duration</option>
              {subscriptionData.map((e, key) => {
              return <option key={key} value={e.id}>{e.subscribeName}</option>;
              })}
              </select>  
              </div>
            
              <div className='col-md-2 col-lg-2 form-group'>
              Invoice Date  <span style={{color:"red"}}>&nbsp;*</span>
              <input name="invoicedate"  type="date" className="form-control"  value={inputs.invoicedate}  onChange={changeVHandler}/>
              </div>
              <div className='col-md-2 col-lg-2 form-group'>
                            Model 
                            <select className="form-control" name="DModel" value={dModel}  onChange={ChangeDModel} >
                            <option value={"GPS-V5"}>GPS-V5</option>               
                            </select>
              </div>
              
              <div className='col-md-4 col-lg-4 form-group'>
              Sales Person : <span style={{color:"red"}}>&nbsp;*</span>  
              <input name="SaleBy"  type="text"   className="form-control"  value={inputs.SaleBy} onChange={changeVHandler}></input>    
              </div>                                                
              <div className='col-md-2 col-lg-2 form-group'>
              Currency <span style={{color:"red"}}>&nbsp;*</span>
                            <select className="form-control" name="dcurrency" value={currencyType}  style={{ "backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px"}}  onChange={ ChangeCurrency} >
                            <option value={"0"}>Select</option>    
                            <option value={"INR"}>INR-Indian Rupee</option>  
                            <option value={"CAD"}>CAD-Canadian Dollar</option>   
                            <option value={"USD"}>USD-US Dollars</option>             
                            </select> 
              </div>
              <div className='col-md-2 col-lg-2 form-group'>
              Payment Terms <span style={{color:"red"}}>&nbsp;*</span>
              <select className="form-control" name="dterms"   value={termType} style={{ "backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px"}} onChange={ ChangeTerms }  >
                            <option value={0}>Select Term</option> 
                            <option value={7}>7 Days</option>    
                            <option value={15}>15 Days</option>  
                            <option value={30}>30 Days</option>   
                            <option value={60}>60 Days</option>           
                </select> 
              </div>
              <div className='col-md-2 col-lg-2 form-group'>
              Due Date 
              <br/>
              <input name="deviceCost"  type="text"  disabled={true} className="form-control"  value={due_Date}  />
              
              </div>
              <div className='col-md-2 col-lg-2 form-group'>
               Price <span style={{color:"red"}}>&nbsp;*</span>
               <input name="deviceCost"  type="text"  maxLength={5} className="form-control"  value={inputs.deviceCost}  onChange={changeVHandler}/>
              </div>
               <div className='col-md-12 col-lg-12  form-group' style={{ marginTop: "17px"}}>
               <center>   <button className="btn btn-primary2" onClick={() => SubmitClick()}>Add</button> </center>
               </div>
               
      </div>
      
      
   
      <div className="row" style={{ padding:"20px", height: "222px", overflowY: "auto" , display: cDisplay }} >
            <table id="example" class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
            <thead>
            <tr>
                   <th style={{ textAlign: "center"}} width="5%">Select</th>
                    <th style={{ textAlign: "center"}} width="10%">Device ID</th>
                    <th style={{ textAlign: "center"}} width="10%">Name</th>                   
                    <th style={{ textAlign: "center"}} width="25%">IMEI#</th>
                    <th style={{ textAlign: "center"}} width="20%">SIM#</th>
                    <th style={{ textAlign: "center"}} width="25%">Expiry Date</th>
                    <th style={{ textAlign: "center"}} width="10%">Price</th>
                    
                                      
            </tr>
            </thead>
            <tbody>
                {renewalDeviceData.map(item => (                    
                <tr key={item.id}>
                 <td style={{ textAlign:"center"}}>  
                 <input  className="form-check-input"  type="checkbox" name={'checkbox'+ rc}  value={item.imeiNumber}  id={'checkbox'+ rc}  onChange={ handleChange } />  </td> 
                  <td style={{ textAlign: "center"}}>{item.id}</td>
                  <td style={{ textAlign:"center"}}>{item.devicename}</td>                  
                  <td style={{ textAlign:"center"}}>{item.imeiNumber}</td>
                  <td style={{ textAlign:"center"}}>{item.mobileNumber}</td>
                  <td style={{ textAlign:"center"}}>{item.expirationDate}</td>
                  <td style={{ textAlign:"center"}}>{inputs.deviceCost}</td>                  
                  <td style={{"display":"none"}}>{rc++}</td> 
                </tr>
                ))}                
            </tbody>
            </table>
            </div>
            <div className='row' style={{ display: cDisplay }}>
                <table>
                    <tr>
                        <td style={{ width:"50%" }}></td>
                        <td style={{ width:"20%" }}>Total Amount</td>
                        <td style={{ width:"10%" }}></td>
                        <td style={{ width:"17%" }}> <input name="totAmount"  type="text"  maxLength={10} className="form-control" style={{textAlign:"right"}}  value={ totAmount.toFixed(2) }  onChange={changeVHandler}/></td>
                        <td style={{ width:"3%" }}></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Discount</td>
                        <td></td>
                        <td> <input name="ddiscount"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={discountVal}  onChange={changeVHandler}/></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td >Installation Charge</td>
                        <td></td>
                        <td> <input name="installationcharge"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={insChargeVal}  onChange={changeVHandler}/></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>CGST%</td>
                        <td>
                            <select className="form-control" name="cgst"   style={{ "backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px", "padding": "5px 5px"}} value={cGstPer} onChange={ ChangeCGST }  >
                            <option value={0}>Select</option> 
                            <option value={9}>9%</option>   
                            <option value={18}>18%</option>        
                            </select>
                        </td>
                        <td> <input name="cgst"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={cGstVal.toFixed(2)}  onChange={changeVHandler}/></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>SGST%</td>
                        <td> <select className="form-control" name="sgst"   style={{ "backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px", "padding": "5px 5px"}} value={sGstPer}  onChange={ ChangeSGST } >
                            <option value={0}>Select</option> 
                            <option value={9}>9%</option>   
                            <option value={18}>18%</option>           
                            </select> 
                        </td>
                        <td><input name="sgst"  type="text"  maxLength={5} className="form-control" style={{textAlign:"right"}} value={sGstVal.toFixed(2)}  onChange={changeVHandler} /></td>
                    </tr>
                    <tr>
                         <td></td>
                        <td>IGST%</td>
                        <td> <select className="form-control" name="igst"   style={{ "backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px", "padding": "5px 5px"}} value={iGstPer}  onChange={ ChangeIGST }  >
                            <option value={0}>Select</option> 
                            <option value={9}>9%</option>   
                            <option value={18}>18%</option>              
                            </select></td>
                        <td> <input name="igst"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={iGstVal.toFixed(2)}  onChange={changeVHandler}/></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Grand Total</td>
                        <td></td>
                        <td> <input name="gtotal"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={ gTotalVal.toFixed(2) }  onChange={changeVHandler}/></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </table>
                </div>     
       <div className='col-md-12 col-lg-12  form-group' style={{ display: btnDisplay, marginTop: "17px"}}>
           <center>    <button className="btn btn-primary2" onClick={() => SaveData()}>Save</button> </center>
               </div>
    
      </div>
      <ToastContainer position="bottom-right" autoClose={4000} theme="light"/> 
    </>
  );
};

  
export default SubscriptionRenewal;